import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'
import { useNavigate } from 'react-router-dom'
import { CaregiverDetailsDisplay, type CaregiverDetailsModel } from 'Components/CareNetwork/CaregiverDetailsDisplay'

interface Props {
  childId: number
  caregiverId: number
  hideEditButton?: boolean
  cardCaption?: string
}

const CaregiverDetails = (props: Props): JSX.Element => {
  const nav = useNavigate()
  const [caregiver, setCaregiver] = useState<CaregiverDetailsModel | null>(null)

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response, success } = await sendGet(
        `/CaregiverDetails/GetDetails?childId=${props.childId}&caregiverId=${props.caregiverId}`, {})

      success && setCaregiver(response.response)
    }

    void fetchData()
  }, [props.childId, props.caregiverId])

  return <CaregiverDetailsDisplay
    caregiver={caregiver}
    caregiverID={props.caregiverId}
    cardCaption={props.cardCaption}
    onEditClick={() => {
      nav(`/CaregiverDetails/Edit/${props.caregiverId}/Child/${props.childId}`)
    }}
  />
}

export default CaregiverDetails
